/* Cookie tracking consent banner: remembers the visitor's choice and, when available, reports it
   to Shopify's Customer Privacy API so it also governs Shopify's own tracking/pixels. */
(function () {
  var KEY = 'ol_cookie_consent';
  var banner = document.getElementById('cookie-consent');
  if (!banner) return;
  var acceptBtn = document.getElementById('cookie-accept');
  var declineBtn = document.getElementById('cookie-decline');

  function stored() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function store(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }
  function hide() { banner.hidden = true; }
  function show() { banner.hidden = false; }

  function applyConsent(accepted) {
    store(accepted ? 'accepted' : 'declined');
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      try { window.Shopify.customerPrivacy.setTrackingConsent(accepted, function () {}); } catch (e) {}
    }
    hide();
  }

  if (acceptBtn) acceptBtn.addEventListener('click', function () { applyConsent(true); });
  if (declineBtn) declineBtn.addEventListener('click', function () { applyConsent(false); });

  var existing = stored();
  if (existing === 'accepted' || existing === 'declined') { hide(); return; }

  if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
    try {
      if (window.Shopify.customerPrivacy.shouldShowBanner()) show(); else hide();
      return;
    } catch (e) {}
  }
  show();
})();
